import {
  useQuery, useInfiniteQuery, UseQueryResult, UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getDrivers } from '../../services/DriversService';
import { DriversResponse } from '../../types/Drivers';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDrivers(fleetId: string, query: string, enabled: boolean = true): UseQueryResult<DriversResponse> {
  return useQuery(
    ['drivers', fleetId, query],
    async (): Promise<DriversResponse> => getDrivers(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled,
    },
  );
}

export function useGetDriversLazy(fleetId: string, payload?: any, query?: string, deps?: any): UseInfiniteQueryResult<DriversResponse> {
  return useInfiniteQuery(
    ['drivers-lazy', fleetId, deps],
    async ({ pageParam = query }): Promise<DriversResponse> => getDrivers(fleetId, pageParam),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => (lastPage?.total ? ((lastPage.limit + lastPage.skip + 1) < lastPage.total) : undefined),
    },
  );
}

export default useGetDrivers;
